import * as React from 'react';

import styles from './List.scss';
import ListItem from './ListItem';

interface ListProps {
  ordered?: boolean;
  className?: string;
  items?: (string | JSX.Element)[];
}

const List: React.SFC<ListProps> = ({ ordered = false, className, items, children }) => {
  const renderChildren = () =>
    items
      ? items.map((item, index) => (
          <ListItem key={index} ordered={ordered}>
            {item}
          </ListItem>
        ))
      : children;

  return ordered ? (
    <ol className={`${styles.list} ${className}`}>{renderChildren()}</ol>
  ) : (
    <ul className={`${styles.list} ${className}`}>{renderChildren()}</ul>
  );
};

export default List;



// WEBPACK FOOTER //
// /www/client/src/components/List/List.tsx